import { Pipe, PipeTransform } from '@angular/core';
import { CompareValues } from '@app/core/models/common.models';
import { percentMetrics } from '@app/core/models/metrics.constants';
import { formatMetric, isGermanLocale, MetricValueFullShort } from '@app/core/services/metrics-calculations.service';
import { FilterTypes } from '@app/core/utilities/refiners.utilities';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ standalone: false, name: 'displayFilterSelection', pure: false })
export class DisplayFilterSelectionPipe implements PipeTransform {
  readonly translations = this.translate.instant('global-filter');

  transform(item): string {
    let selectedValues;
    switch (item.type) {
      case FilterTypes.multi:
        selectedValues = item.options.filter((d) => d.selected);

        return !selectedValues.length || item.options.length === selectedValues.length
          ? `${item.displayName}: ${this.translations.all}`
          : selectedValues.map((d) => d.text).join(', ');
      case FilterTypes.single:
        selectedValues = item.options.filter((d) => d.selected);
        return selectedValues.length ? selectedValues[0].text : `${item.displayName}: -`;
      case FilterTypes.query:
        return `${item.displayName} ${this.translations[item.queryKeyword]} '${item.value || ''}'`;
      case FilterTypes.queryMultiple:
        return `${item.displayName} ${this.translations[item.queryKeyword]} '${item.value || ''}'`;
      case FilterTypes.switch:
        return `${item.displayName}: ${item.value ? item.on : item.off}`;
      case FilterTypes.compare:
        const comparator = this._getComparator(item.comparator);
        const firstValueText = this._displayText(item, item.value);
        const endRangeText =
          item.comparator !== CompareValues.RANGE ? '' : ' - ' + this._displayText(item, item.endRange);

        return `${item.displayName}: ${this.translations['sub-filters'][comparator]} ${firstValueText + endRangeText}`;
      default:
        return '';
    }
  }

  private _getComparator(comparator: CompareValues) {
    switch (comparator) {
      case CompareValues.LE:
        return 'is-less';
      case CompareValues.GE:
        return 'is-greater';
      case CompareValues.RANGE:
        return 'range';
      default:
        return 'is-equals';
    }
  }

  private _displayText(item: any, v) {
    const value = parseFloat(isGermanLocale() ? v?.replace(',', '.') : v);
    const metric = formatMetric(item.columnName, percentMetrics.includes(item.columnName) ? value / 100 : value);
    return `${item.currency || ''}${MetricValueFullShort(metric, item.columnName)}`;
  }
  constructor(private translate: TranslateService) {}
}
